export const RESET = 'RESET';

// Set All Products.
export const SET_ALL_PRODUCTS = 'SET_ALL_PRODUCTS';
export const SET_NEXT_FETCH_MODE = 'SET_NEXT_FETCH_MODE';

// Get Products.
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR';
